var map = {
	"./apple.svg": "bb76",
	"./cart.svg": "5fc8",
	"./check.svg": "c800",
	"./chevron-down.svg": "880b",
	"./clock.svg": "f627",
	"./close.svg": "0426",
	"./credit-card.svg": "dc50",
	"./delete.svg": "a063",
	"./edit.svg": "84c3",
	"./email-outline.svg": "62a8",
	"./email-solid.svg": "7277",
	"./email.svg": "d20d",
	"./facebook-circle.svg": "df61",
	"./facebook.svg": "8699",
	"./foursquare.svg": "c132",
	"./glovo.svg": "4694",
	"./google-original.svg": "c311",
	"./google.svg": "5d5c",
	"./hamburger.svg": "196c",
	"./history.svg": "d6bf",
	"./home.svg": "088f",
	"./instagram.svg": "19bd",
	"./location.svg": "518c",
	"./logout.svg": "157f",
	"./loyalty.svg": "756a",
	"./minus-circle.svg": "9f06",
	"./minus.svg": "0a43",
	"./next.svg": "2af4",
	"./notification.svg": "1972",
	"./password.svg": "9bcd",
	"./perfect-match.svg": "5e7d3",
	"./pinterest.svg": "8601",
	"./plus-circle.svg": "31d2",
	"./plus.svg": "4945",
	"./prev.svg": "3c45",
	"./search.svg": "0eeb",
	"./tripadvisor.svg": "9172",
	"./twitter.svg": "fea9",
	"./user-friends.svg": "f4e3",
	"./user.svg": "2f00",
	"./vegan.svg": "16a6",
	"./wheat.svg": "043c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "94d3";